import { MillwrightsRiskOption, MillwrightsSortOption } from '@/types';

export const INITIAL_SORT_DIRECTION = 'desc';

export const millwrightsSortOptions: MillwrightsSortOption[] = [
  {
    value: 'name-asc',
    label: 'Name (A-Z)',
    sortBy: 'name',
    sortDir: 'asc',
  },
  {
    value: 'name-desc',
    label: 'Name (Z-A)',
    sortBy: 'name',
    sortDir: 'desc',
  },
  {
    value: 'risk-asc',
    label: 'Risk (Low to High)',
    sortBy: 'risk',
    sortDir: 'asc',
  },
  {
    value: 'risk-desc',
    label: 'Risk (High to Low)',
    sortBy: 'risk',
    sortDir: 'desc',
  },
];

export const millwrightsRiskOptions: MillwrightsRiskOption[] = [
  {
    value: 'all',
    label: 'All',
    range: null,
  },
  {
    value: 'low',
    label: 'Low',
    range: [0, 62.49],
  },
  {
    value: 'moderate',
    label: 'Moderate',
    range: [62.5, 67.99],
  },
  {
    value: 'elevated',
    label: 'Elevated',
    range: [68, 73.99],
  },
  {
    value: 'significant',
    label: 'Significant',
    range: [74, 79.99],
  },
  {
    value: 'high',
    label: 'High',
    range: [80, 85.99],
  },
  {
    value: 'very-high',
    label: 'Very High',
    range: [86, 93.99],
  },
  {
    value: 'extreme',
    label: 'Extreme',
    range: [94, 100],
  },
];
